import { formatISO, isValid } from "date-fns";
import range from "lodash.range";
import React, { useEffect, useState } from "react";
import Select from "../Select";

const BirthdateInput = ({
  value,
  onChange,
}: {
  value: string;
  onChange: (date: string | null) => void;
}) => {
  const [month, setMonth] = useState<number>();
  const [day, setDay] = useState<number>();
  const [year, setYear] = useState<number>();

  useEffect(() => {
    if (month && day && year) {
      if (isValidDate(day, month, year)) {
        const result = formatISO(new Date(year, month, day), {
          representation: "date",
        });
        onChange(result);
      }
    }
    // TODO: Consider adding onChange...
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [month, day, year]);

  useEffect(() => {
    const valueDate = new Date(value);
    if (value && isValid(valueDate)) {
      setDay(valueDate.getUTCDate());
      setMonth(valueDate.getUTCMonth());
      setYear(valueDate.getUTCFullYear());
    }
  }, [value]);

  const endYear = new Date().getUTCFullYear();
  const yearOptions = range(endYear - 120, endYear + 1)
    .map((year) => ({
      label: `${year}`,
      value: `${year}`,
    }))
    .reverse();
  const yearValue = yearOptions.find((opt) => opt.value === `${year}`);
  const monthOptions = MONTH_OPTIONS.map((month, i) => ({
    label: month,
    value: `${i}`,
  }));
  const monthValue = monthOptions.find((opt) => opt.value === `${month}`);

  const dayOptions = range(1, daysInMonth(month || 2, year || endYear) + 1).map(
    (day) => ({
      label: `${day}`,
      value: `${day}`,
    })
  );
  const dayValue = dayOptions.find((opt) => opt.value === `${day}`);

  return (
    <div className="flex">
      <Select
        className="flex-1 mr-1"
        placeholder="Month"
        options={monthOptions}
        value={monthValue}
        onChange={(val) => {
          if (val) {
            const parsedInt = parseInt(val.value);
            if (!isNaN(parsedInt)) {
              setMonth(parsedInt);
            } else {
              setMonth(undefined);
            }
          } else {
            setMonth(undefined);
          }
        }}
      />
      <Select
        className="flex-1 mx-1"
        placeholder="Day"
        options={dayOptions}
        value={dayValue}
        onChange={(val) => {
          if (val) {
            const parsedInt = parseInt(val.value);
            if (!isNaN(parsedInt)) {
              setDay(parsedInt);
            } else {
              setDay(undefined);
            }
          } else {
            setDay(undefined);
          }
        }}
      />
      <Select
        className="flex-1 ml-1"
        placeholder="Year"
        options={yearOptions}
        value={yearValue}
        onChange={(val) => {
          if (val) {
            const parsedInt = parseInt(val.value);
            if (!isNaN(parsedInt)) {
              setYear(parsedInt);
            } else {
              setYear(undefined);
            }
          } else {
            setYear(undefined);
          }
        }}
      />
    </div>
  );
};

const MONTH_OPTIONS = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

function daysInMonth(m: number, y: number) {
  switch (m) {
    case 1:
      return (y % 4 === 0 && y % 100) || y % 400 === 0 ? 29 : 28;
    case 8:
    case 3:
    case 5:
    case 10:
      return 30;
    default:
      return 31;
  }
}

function isValidDate(d: number, m: number, y: number) {
  return m >= 0 && m < 12 && d > 0 && d <= daysInMonth(m, y);
}

export default BirthdateInput;
